export function formatMMDDYYYY(date: Date): string {
  if (!date) return '';
  date = new Date(date);

  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}
